import React from 'react'
import ConditionTwoButtonsModal from './ConditionTwoButtonsModal'
import YesItsPerfectComponentWrapper from './YesItsPerfectComponentWrapper'
import { ContactPageNumber } from '../../constants'
import { pageObject } from '../../constants/pageObject'
import useEventBus from '../generic/useEventBus'

export default ({ showModal, nextClick, onCloseModal, addImpressions, updateGlobalState, tab, urlState, shouldShowOfferCreationComponent = false, theme }) => {
  const onClickPositive = () => {
    urlState['noDamageModal'] = true
    !shouldShowOfferCreationComponent && updateGlobalState({ fireAnalytics: 'sm_skip_to_next_steps_modal_btn', cp: pageObject[tab] })
    nextClick(ContactPageNumber)
  }
  const onClickNegative = () => {
    const analytics = []
    addImpressions && addImpressions(analytics)
    !shouldShowOfferCreationComponent && updateGlobalState({ fireAnalytics: 'sm_return_to_questionnaire_btn', cp: pageObject[tab] })
    onCloseModal()
  }

  if (shouldShowOfferCreationComponent) {
    useEventBus('YesItsPerfectModalYesClicked', _ => onClickPositive())

    useEventBus('YesItsPerfectModalClosed', _ => onClickNegative())
  }

  const showConditionModal = () => {
    return (
      (showModal === true || showModal === false) && (
        <div>
          <ConditionTwoButtonsModal
            name={'NoDamageIndicatorModal'}
            testId={`vc-no-damage-modal`}
            positiveCopyOverride={"Yes! It's Perfect"}
            onClickPositive={() => onClickPositive()}
            negativeCopyOverride={'Return to Questionnaire'}
            onClickNegative={() => onClickNegative()}
            title={'Is Your Vehicle Really Free from Damage, Wear or Problems?'}
            open={showModal}
            minHeight={'100px'}
            closeOnClickOutside={false}></ConditionTwoButtonsModal>
        </div>
      )
    )
  }

  const showConditionWebComponent = () => {
    return showModal === true && <YesItsPerfectComponentWrapper theme={theme}></YesItsPerfectComponentWrapper>
  }

  return shouldShowOfferCreationComponent ? showConditionWebComponent() : showConditionModal()
}
